<template>
  <div
    class="d-flex align-center px-4"
    style="min-height: 48px"
  >
    <img
      src="@/assets/XD.svg"
      alt="XDLogo44x28"
    />
    <h1 class="text-subtitle-2 ps-2">{{ title }}</h1>
    <v-spacer></v-spacer>

    <v-btn
      icon
      variant="text"
      @click="messageWidth = 268"
      v-if="tokenValid"
    >
      <v-badge
        color="error"
        :content="showUnreadCount()"
        overlap
      >
        <v-icon color="block">mdi-message-outline</v-icon>
      </v-badge>

      <v-menu activator="parent">
        <v-card :style="`
                      min-width: ${messageWidth}px;
                      max-width: ${messageWidth === '268px' ? 'none' : '440px'}`">
          <!-- 訊息通知 -->
          <div v-if="messageWidth === 268">
            <div class="pa-7">
              <p class="mb-0 font-weight-bold">訊息通知</p>
            </div>

            <v-divider></v-divider>

            <a
              href="#"
              :class="{ 'bg-unread': !item.IsRead }"
              class="d-block text-decoration-none text-black px-7 py-3"
              v-for="item in notificationData"
              :key="item"
              @click.prevent.stop="openOrCloseMessage(true, item)"
            >
              <div style="width: 256px">
                <p class="mb-0">{{ item.NotiTypeName }}</p>
                <p class="ellipsis text-caption">
                  {{ item.MessageTitle }}
                </p>
              </div>
            </a>
          </div>

          <!-- 訊息通知展開 -->
          <div v-else>
            <div class="pa-9">
              <a
                href="#"
                class="text-decoration-none text-black text-caption font-weight-bold"
                @click.prevent.stop="openOrCloseMessage(false)"
              >
                <v-icon
                  icon="mdi-chevron-left"
                  class="me-4"
                ></v-icon>
                <span>返回</span>
              </a>
            </div>

            <div class="px-7 pb-7">
              <div class="d-flex justify-space-between">
                <h6 class="text-subtitle-1 font-weight-bold mb-4">
                  【{{ focusMessage.NotiTypeName }}】
                </h6>
                <span class="text-caption">{{ timeSplit(focusMessage.SendTime) }}</span>
              </div>
              <p class="font-weight-bold mb-5">{{ focusMessage.MessageTitle }}</p>
              <p class="mb-5">
                {{ focusMessage.MessageBody }}
              </p>
              <a
                href="#"
                class="text-decoration-none text-primary"
              >前往xRule查看</a>
            </div>
          </div>
        </v-card>
      </v-menu>
    </v-btn>

    <v-btn
      class="me-0"
      icon
      variant="text"
      v-if="tokenValid"
    >
      <v-icon color="block">mdi-account-circle</v-icon>

      <v-menu activator="parent">
        <v-card min-width="256">
          <div
            class="px-5 pt-5 pb-4"
            v-if="userInfoSortOutData"
          >
            <p class="mb-0">
              {{ userInfoSortOutData.lastName }}{{ userInfoSortOutData.firstName }}
            </p>
            <p>{{ userInfoSortOutData.email }}</p>
          </div>

          <a
            :href="userUrl"
            class="d-flex align-center text-decoration-none text-black px-5 py-3"
          >
            <v-icon
              icon="mdi-account-circle"
              class="me-4"
            ></v-icon>
            <span>我的帳戶</span>
          </a>

          <v-divider></v-divider>

          <a
            href="#"
            class="d-flex align-center text-decoration-none text-black px-5 py-3"
            @click="executionLogout()"
          >
            <v-icon
              icon="mdi-logout"
              class="me-4"
            ></v-icon>
            <span>登出</span>
          </a>
        </v-card>
      </v-menu>
    </v-btn>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import messageStore from "code-library/store/message.js";
import userStore from "code-library/store/user.js";
import axiosAPIStore from "code-library/store/axiosAPI.js";
import formatConversionStore from "code-library/store/formatConversion.js";
import indexStore from "code-library/store/index.js";


import { storeToRefs } from "pinia";
// import { useRouter, useRoute } from "vue-router";

// const router = useRouter();
// const route = useRoute();
const message = messageStore();
const userfun = userStore();
const axiosAPI = axiosAPIStore();
const formatConversion = formatConversionStore();
const index = indexStore();

// -------------------------------------------------------------

// state
const { notificationData } = storeToRefs(message);
const { userInfoSortOutData } = storeToRefs(userfun);
const { tokenValid } = storeToRefs(axiosAPI);


// actions
const { getNotification } = message;
const { getUserAllData } = userfun;
const { axiosFun, deleteCookieByName, checkTokenStatus } = axiosAPI;
const { timeSplit } = formatConversion;
const { logout } = index;

// -------------------------------------------------------------

// API

// 修改訊息通知已讀狀態
async function alterNotificationIsRead(id) {
  const url = `${process.env.VUE_APP_APIPATH_B}Notification/AlterNotificationIsRead?Id=${id}`;

  return await axiosFun(url, "post");
}

// -------------------------------------------------------------

const title = ref("xObject 元件庫");
const userUrl = ref(
  `${process.env.VUE_APP_USER}account_information/personal_information`
);

// 初始
async function init() {
  await getNotification();
  await getUserAllData();
}

onMounted(async () => {
  // 檢查 token 是否在 pinia且是否有效
  tokenValid.value = await checkTokenStatus();

  if (!tokenValid.value) return;
  await init();
});

// 執行登出
async function executionLogout() {
  await logout();
  localStorage.removeItem("prodAuth");
  localStorage.removeItem("token");
  localStorage.removeItem("id");
  localStorage.removeItem("pricingPlanId");
  localStorage.removeItem("orgId");
  localStorage.removeItem("projectId");

  localStorage.removeItem("wvUserLoginMode");
  localStorage.removeItem("path");

  localStorage.removeItem("searchKeyWords");
  localStorage.removeItem("searchComponentData");

  deleteCookieByName("prodAuth");
  deleteCookieByName("accessToken");
  deleteCookieByName("refreshToken");
  deleteCookieByName("id");
  deleteCookieByName("pricingPlanId");
  deleteCookieByName("orgId");
  deleteCookieByName("projectId");
  deleteCookieByName("wvUserLoginMode");
  deleteCookieByName("path");
  deleteCookieByName("login");

  window.location.href = `${process.env.VUE_APP_LOGIN}`;
}

// 顯示未讀數量
function showUnreadCount() {
  if (!notificationData.value || notificationData.value.length === 0) return 0;

  return notificationData.value.filter((item) => !item.IsRead).length;
}

const messageWidth = ref(268);
const focusMessage = ref({});

async function openOrCloseMessage(judge, item) {
  if (judge) {
    await alterNotificationIsRead(item.Id);
    await getNotification();

    messageWidth.value = 440;
    focusMessage.value = item;
  } else {
    messageWidth.value = 268;
  }
}
</script>

<style lang="scss" scoped>
.bg-unread {
  background: rgba(25, 118, 210, 0.06);
}

.text-565656 {
  color: #565656;
}

.ellipsis {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
